var map = {
	"./age_rating_0.svg": 725,
	"./age_rating_12.svg": 726,
	"./age_rating_16.svg": 727,
	"./age_rating_18.svg": 728,
	"./age_rating_7.svg": 729,
	"./app_store.svg": 387,
	"./app_store_full.svg": 730,
	"./appstore.svg": 731,
	"./arrow_xl_l.svg": 732,
	"./arrow_xl_r.svg": 733,
	"./blik.svg": 734,
	"./blue_logo.svg": 107,
	"./bluemedia.svg": 735,
	"./calendar.svg": 736,
	"./close.svg": 737,
	"./close_thin.svg": 738,
	"./content_rating_n.svg": 739,
	"./content_rating_p.svg": 740,
	"./content_rating_s.svg": 741,
	"./content_rating_w.svg": 742,
	"./dcb.svg": 743,
	"./device_pc.svg": 744,
	"./device_phone.svg": 745,
	"./device_tablet.svg": 746,
	"./device_tv.svg": 747,
	"./exit_fullscreen.svg": 748,
	"./facebook.svg": 749,
	"./fullscreen-vod.svg": 750,
	"./fullscreen.svg": 751,
	"./google_play_full.svg": 752,
	"./googleplay.svg": 753,
	"./ic_EU.svg": 754,
	"./ic_EU_PL.svg": 755,
	"./ic_adult.svg": 756,
	"./ic_app_store.svg": 757,
	"./ic_arrow_down.svg": 758,
	"./ic_arrow_l.svg": 759,
	"./ic_arrow_r.svg": 760,
	"./ic_auth_facebook.svg": 761,
	"./ic_auth_google.svg": 762,
	"./ic_back.svg": 763,
	"./ic_basket.svg": 764,
	"./ic_bell.svg": 765,
	"./ic_blik.svg": 766,
	"./ic_bluemedia.svg": 767,
	"./ic_clock.svg": 768,
	"./ic_close.svg": 769,
	"./ic_close_thin.svg": 770,
	"./ic_content_info.svg": 771,
	"./ic_delete.svg": 772,
	"./ic_epg_left.svg": 773,
	"./ic_epg_right.svg": 774,
	"./ic_facebook.svg": 775,
	"./ic_favorite.svg": 776,
	"./ic_favorite_border.svg": 777,
	"./ic_favorite_full.svg": 778,
	"./ic_gears.svg": 779,
	"./ic_google.svg": 780,
	"./ic_google_play.svg": 781,
	"./ic_grid.svg": 782,
	"./ic_home.svg": 783,
	"./ic_info.svg": 784,
	"./ic_instagram.svg": 785,
	"./ic_institution.svg": 786,
	"./ic_link_facebook.svg": 787,
	"./ic_link_instagram.svg": 788,
	"./ic_link_pinterest.svg": 789,
	"./ic_link_tiktok.svg": 790,
	"./ic_link_twitter.svg": 791,
	"./ic_list.svg": 792,
	"./ic_lock.svg": 793,
	"./ic_lock_second.svg": 794,
	"./ic_mastercard.svg": 795,
	"./ic_nav_favorite.svg": 796,
	"./ic_nav_kontrast.svg": 797,
	"./ic_nav_profile.svg": 798,
	"./ic_nav_reminder.svg": 799,
	"./ic_nav_search.svg": 800,
	"./ic_operator_orange.svg": 801,
	"./ic_operator_play.svg": 802,
	"./ic_operator_plus.svg": 803,
	"./ic_operator_t_mobile.svg": 804,
	"./ic_pause.svg": 805,
	"./ic_payment_arrow.svg": 806,
	"./ic_phone.svg": 807,
	"./ic_play.svg": 808,
	"./ic_play_xl.svg": 809,
	"./ic_player_fullscreen copy.svg": 810,
	"./ic_player_fullscreen.svg": 811,
	"./ic_player_fullscreen_close.svg": 812,
	"./ic_player_minus_15.svg": 813,
	"./ic_player_play.svg": 814,
	"./ic_player_plus_15.svg": 815,
	"./ic_player_settings.svg": 816,
	"./ic_player_stop.svg": 817,
	"./ic_player_volume_off.svg": 818,
	"./ic_player_volume_on.svg": 819,
	"./ic_profile.svg": 820,
	"./ic_rec.svg": 821,
	"./ic_reminder.svg": 822,
	"./ic_search.svg": 823,
	"./ic_share.svg": 824,
	"./ic_tick.svg": 825,
	"./ic_tick_circle.svg": 826,
	"./ic_trash.svg": 827,
	"./ic_tv.svg": 828,
	"./ic_twitter.svg": 829,
	"./ic_vimeo.svg": 830,
	"./ic_visa.svg": 831,
	"./ic_vod_favorite.svg": 832,
	"./ic_wcag_animation.svg": 833,
	"./ic_wcag_animation_play.svg": 834,
	"./ic_wcag_contrast.svg": 835,
	"./ic_wcag_disability.svg": 836,
	"./ic_wcag_reset.svg": 837,
	"./ic_wcag_text_large.svg": 838,
	"./ic_wcag_text_medium.svg": 839,
	"./ic_wcag_text_small.svg": 840,
	"./ic_youtube.svg": 841,
	"./icon_back_mobile.svg": 842,
	"./icon_mobile_menu_arrow_down.svg": 843,
	"./mc.svg": 844,
	"./minimalize.svg": 845,
	"./new_ic_bell.svg": 846,
	"./next.svg": 847,
	"./pause.svg": 848,
	"./play.svg": 849,
	"./previous.svg": 850,
	"./seek_15_next.svg": 851,
	"./seek_15_prev.svg": 852,
	"./settings.svg": 853,
	"./star_empty.svg": 854,
	"./star_full.svg": 855,
	"./test/search_icon.svg": 856,
	"./test/share_icon.svg": 857,
	"./tick.svg": 858,
	"./triangle-border.svg": 389,
	"./triangle.svg": 859,
	"./underline.svg": 860,
	"./visa.svg": 861,
	"./vod_heart.svg": 862,
	"./vod_heart_full.svg": 863,
	"./vod_play.svg": 864,
	"./volume.svg": 865,
	"./volume_off.svg": 866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 724;